import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTransporterInfo } from "../hooks/useTransporterInfo";
import { SubscriptionType } from "../interfaces/transporters.interface";
import { Chapter } from "../interfaces/chapters.interface";
import ChapterService from "../service/ChapterService";
import PremiumFeatureNotice from "../components/chapters/PremiumFeatureNotice";
import LoadingSpinner from "../components/chapters/LoadingSpinner";
import ChapterEditForm from "../components/chapters/ChapterEditForm";

const ChapterEdit: React.FC = () => {
  const { transporterInfo } = useTransporterInfo();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [chapter, setChapter] = useState<Chapter | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const chapterService = new ChapterService();
    const loadChapter = async () => {
      if (!id) {
        history.push("/chapters");
        return;
      }

      try {
        const response = await chapterService.getChapterById(id);
        // Verify if the transporter owns this chapter
        if (!transporterInfo._id || !response.transporters.includes(transporterInfo._id)) {
          history.push("/chapters");
          return;
        }
        setChapter(response);
      } catch (error) {
        console.error("Error loading chapter:", error);
        history.push("/chapters");
      } finally {
        setIsLoading(false);
      }
    };

    if (transporterInfo._id) {
      loadChapter();
    }
  }, [id, transporterInfo._id, history]);

  const handleChapterUpdated = () => {
    history.push("/chapters");
  };

  if (transporterInfo.subscriptionType !== SubscriptionType.PAID) {
    return <PremiumFeatureNotice />;
  }

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!chapter) {
    return null;
  }

  return (
    <div className="flex flex-col h-[calc(100vh-70px)] bg-slate-50">
      <div className="px-12 flex flex-col h-full">
        <div className="flex-shrink-0 mb-6 flex justify-between items-center">
          <h1 className="text-3xl font-bold">Modifier le chapitre</h1>
          <button
            onClick={() => history.push("/chapters")}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            <i className="ph-bold ph-arrow-left mr-2"></i>
            Retour
          </button>
        </div>
        <div className="flex-1 min-h-0">
          <div className="bg-white shadow-md rounded-lg p-6 h-full">
            <ChapterEditForm 
              chapter={chapter}
              onChapterUpdated={handleChapterUpdated} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChapterEdit;
